import React, { useEffect, useState } from 'react';
import './Adminpanel.css';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../Context/Authcontext';

function Adminpanel() {

  const { setBardis, isadmin, setIsadmin, encryptData, key } = useAuth();
  const [navOpen, setNavOpen] = useState(false);
  const [form, setForm] = useState({ username: '', password: '' });
  const location = useLocation();

  useEffect(() => { window.scrollTo(0, 0); }, []);

  useEffect(() => {
    if (localStorage.getItem("adlocprodat")) {
      setIsadmin(true);
    }
  }, [setIsadmin]);

  // Close nav on desktop by default, open by default on desktop
  useEffect(() => {
    if (window.innerWidth >= 800) setNavOpen(true);
  }, []);

  useEffect(() => {
    setBardis(true);
    return () => { setBardis(false); };
  }, [setBardis]);

  // Close mobile nav when route changes
  useEffect(() => {
    if (window.innerWidth < 800) setNavOpen(false);
  }, [location.pathname]);

  const loginFunc = () => {
    if (form.username && form.password) {
      fetch(`https://pentadeco.in/api/adminlogin`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      }).then(res => res.json()).then(data => {
        if (data.success) {
          setIsadmin(true);
          const secdata = encryptData(data?.pro, key);
          localStorage.setItem('adlocprodat', secdata);
        }
      }).catch(err => console.error('error occured while logging in as admin ', err));
    }
  };

  const navItems = [
    { label: 'DASHBOARD', icon: 'fas fa-th-large', to: '/dashboard' },
    { label: 'PRODUCTS',  icon: 'fas fa-box',       to: '/dashboard/products' },
    { label: 'ORDERS',    icon: 'fas fa-clipboard-list', to: '/dashboard/orders' },
    { label: 'UPLOAD',    icon: 'fas fa-plus-square', to: '/dashboard/upload' },
    { label: 'COUPONS',   icon: 'fas fa-tag',        to: '/dashboard/coupons' },
  ];

  return (
    <div className='main-dashboard my-0'>
      {isadmin ? (
        <div className="m-0 p-0">
          {/* Mobile overlay */}
          <div
            className={`dash-overlay ${navOpen ? 'mob-nav-open' : ''}`}
            onClick={() => setNavOpen(false)}
          />

          <div className="container-fluid main-dashboard-contianer row align-items-start m-0 p-0">
            {/* Sidebar */}
            <div className={`dash-nav ${navOpen ? 'mob-nav-open' : ''}`}>
              <div>
                <Link to='/' className='dash-nav-logo nav-link'>
                  <img src="/assets/dash-logo.png" alt="dashboard logo" className="img-fluid" />
                </Link>
                <ul className="dash-ul p-0 m-0">
                  {navItems.map((item, i) => (
                    <li
                      key={i}
                      className={`${location.pathname === item.to ? 'dash-nav-active' : ''}`}
                    >
                      <Link to={item.to} className='nav-link py-1 body-font-medium'>
                        <i className={`${item.icon} me-2`}></i>{item.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <button
                className="dash-logout-btn"
                onClick={() => { localStorage.clear(); window.location.reload(); }}
              >
                <i className="fas fa-power-off"></i> Log out
              </button>
            </div>

            {/* Content */}
            <div className="col dash-content-col p-0 pt-4">
              <Outlet />
            </div>
          </div>

          {/* Hamburger */}
          <div className="nav-icon-wrap">
            <div className="ad-ham-wrap" onClick={() => setNavOpen(o => !o)}>
              <i className={`fas fa-${navOpen ? 'times' : 'bars'}`}></i>
            </div>
          </div>
        </div>
      ) : (
        <div className="login-form-wrap">
          <div className="ad-form-wrap">
            <div className="ad-form-brand">
              <img src="/assets/dash-logo.png" alt="logo" />
            </div>
            <p className="ad-form-title">Admin Login</p>
            <p className="ad-form-sub">Enter your credentials to continue</p>

            <div className="ad-input-group">
              <label className="ad-input-label">USERNAME</label>
              <input
                type="text"
                className="ad-input"
                placeholder="Enter username"
                value={form.username}
                onChange={e => setForm(x => ({ ...x, username: e.target.value }))}
                onKeyDown={e => e.key === 'Enter' && loginFunc()}
              />
            </div>
            <div className="ad-input-group">
              <label className="ad-input-label">PASSWORD</label>
              <input
                type="password"
                className="ad-input"
                placeholder="Enter password"
                value={form.password}
                onChange={e => setForm(x => ({ ...x, password: e.target.value }))}
                onKeyDown={e => e.key === 'Enter' && loginFunc()}
              />
            </div>
            <button className="ad-login-btn" onClick={loginFunc}>
              LOGIN &nbsp;<i className="fas fa-arrow-right"></i>
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Adminpanel;
